import { render, staticRenderFns } from "./BusinessInsuranceAggregate.vue?vue&type=template&id=582d13b7&scoped=true&"
import script from "./BusinessInsuranceAggregate.vue?vue&type=script&lang=ts&"
export * from "./BusinessInsuranceAggregate.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessInsuranceAggregate.vue?vue&type=style&index=0&id=582d13b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d13b7",
  null
  
)

export default component.exports